import React from "react";
import PropTypes from "prop-types";

import { BecomeADealer } from "./components/become-a-dealer";
import { DealerBenefits } from "./components/dealer-benefits";

import { Content, StyledP2, Title } from "./styles";

export const Success = () => {
  return (
    <div>
      <BecomeADealer />
      <Content>
        <DealerBenefits />
        <div>
          <Title>Thank You</Title>
          <br />
          <StyledP2
            css={`
              color: ${({
                theme: {
                  colors: { grey },
                },
              }) => grey};
            `}
          >
            {
              "We will review your application and contact you shortly. If you have any questions, please give us a call at 508-535-5100."
            }
          </StyledP2>
        </div>
      </Content>
    </div>
  );
};

Success.propTypes = {
  action: PropTypes.string,
};
